// extracted by mini-css-extract-plugin
module.exports = {"reveal":"HeaderTextAnimation_reveal__xlwO4","hidden":"HeaderTextAnimation_hidden__UHV1R"};